export const UserControllerFactory = ({
  userService,
}: {
  userService: IUserService;
}) => {
  const getUserBetaFeatures: IGetUserBetaFeaturesController = async () => {
    const userBetaFeature = await userService.getUserBetaFeatures();
    return userBetaFeature;
  };

  const updateUserInfo: IUpdateUserInfoController = async (payload) => {
    const userInfo = await userService.updateUserInfo(payload);
    return userInfo;
  };

  const signupUser: ISignupUserController = async (payload) => {
    const user = await userService.signupUser(payload);
    return user;
  };

  const getAdminPendingUsers: IGetAdminPendingUsersController = async (
    payload
  ) => userService.getAdminPendingUsers(payload);

  const activateAdminPendingUser: IActivateAdminPendingUserController = async (
    payload
  ) => userService.activateAdminPendingUser(payload);

  const getClinicUsers: IGetClinicUsersController = async (payload) =>
    userService.getClinicUsers(payload);

  const setUserPassword: ISetUserPasswordController = async (payload) =>
    userService.setUserPassword(payload);

  const disconnectDevice: IDisconnectDeviceController = async (payload) =>
    userService.disconnectDevice(payload);

  return {
    getUserBetaFeatures,
    updateUserInfo,
    signupUser,
    getAdminPendingUsers,
    activateAdminPendingUser,
    getClinicUsers,
    setUserPassword,
    disconnectDevice,
  };
};
